module.exports = {
      id: "star-usage",
      viewBox: "0 0 36.688 45.344",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#star",
      toString: function () {
        return this.url;
      }
    }